import { Message, useMessageGetter } from '@messageformat/react';
import { FunctionComponent, SVGProps, useEffect, useRef } from 'react';
import styles from './CourseHeader.module.scss';

interface HeaderProps {
  courseTitleId: string;
  courseHeaderText: string;
  Image: FunctionComponent<SVGProps<SVGSVGElement>>;
  courseNumber: number;
}

const CourseHeader = (props: HeaderProps): JSX.Element => {
  const { courseTitleId, courseHeaderText, Image, courseNumber } = props;
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    if (headingRef.current) {
      headingRef.current.focus();
    }
  }, [courseTitleId]);
  const getMessage = useMessageGetter('');
  return (
    <div className={styles.container}>
      <div aria-hidden="true" className="opds-styles-v1-text-title-small-strong">
        {courseNumber} - <Message id={courseHeaderText} />
      </div>
      <h1 ref={headingRef} tabIndex={-1} className="opds-styles-v1-text-hero-medium">
        <span className="sr-only">
          {`${getMessage('investor_academy_title')}: ` +
            `${getMessage(courseHeaderText)}. ` +
            `${getMessage('course')} ${courseNumber}. `}
        </span>
        <Message id={courseTitleId} />
      </h1>
      <Image aria-hidden="true" className={styles.image} />
    </div>
  );
};

export default CourseHeader;
